<template>
  <div class="piezoelectric-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Q = d · F | 电能 ↔ 机械能$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Piezo Crystal Block -->
          <rect x="150" :y="100 - compression" width="100" height="60 + compression*2" rx="4" fill="rgba(0, 210, 255, 0.2)" stroke="#00d2ff" stroke-width="2" />
          
          <!-- Charge accumulation on surfaces -->
          <g v-if="force > 0">
             <text v-for="i in 5" :key="'p'+i" :x="160 + i*15" :y="90 - compression" fill="#ff4757" font-size="12" font-weight="bold">+</text>
             <text v-for="i in 5" :key="'n'+i" :x="160 + i*15" :y="180 + compression" fill="#2ed573" font-size="12" font-weight="bold">-</text>
          </g>

          <!-- Piston / Hammer -->
          <rect x="140" :y="40 - compression" width="120" height="20" fill="#333" rx="4" />
          <text x="175" :y="30 - compression" fill="#ff4757" font-size="10" font-weight="bold" v-if="force > 0">压力 F</text>

          <!-- Voltmeter -->
          <g transform="translate(300, 100)">
             <circle r="30" fill="#111" stroke="#555" />
             <line x1="0" y1="0" :x2="25 * Math.sin(voltage/10)" :y2="-25 * Math.cos(voltage/10)" stroke="#ffd700" stroke-width="2" />
             <text x="0" y="45" text-anchor="middle" fill="#ffd700" font-size="10">{{ voltage.toFixed(1) }} V</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>机械形变产生感应电荷</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>施加压力</label>
             <el-slider v-model="force" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>某些电介质晶体（如石英、钛酸钡）在受到定向压力发生形变时，由于内部**正负电荷中心不重合**，会在两端表面产生极性相反的电荷。反之，施加电压也会引起机械形变。这一效应广泛用于打火机、传感器、声呐及精密定位系统。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PiezoelectricEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      force: 0
    }
  },
  computed: {
    compression() { return this.force * 0.1; },
    voltage() { return this.force * 0.5; }
  }
}
</script>

<style scoped lang="scss">
.piezoelectric-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
